import { createFileRoute } from '@tanstack/react-router';
import FolderRouteLayout from '../components/FolderRouteLayout';

export const Route = createFileRoute('/_app/folder/$folderId')({
  component: FolderRouteLayout,
});
